import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/** Sinif adlarini birlestirir; cakisan Tailwind siniflarinda son yazan kazanir. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
